import { render } from "./AnimeNewSwiper.vue?vue&type=template&id=71d3e070"
import script from "./AnimeNewSwiper.vue?vue&type=script&lang=js"
export * from "./AnimeNewSwiper.vue?vue&type=script&lang=js"

import "./AnimeNewSwiper.vue?vue&type=style&index=0&id=71d3e070&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__